import type { ApiClient } from "@/lib/api";
import type { BulkUpsertHooksRequest, BulkUpsertHooksResponse } from "../types";

/**
 * Bulk update hooks - allows updating priority, status, phase, and failure_mode
 * for multiple hooks at once.
 */
export const bulkUpdateHooks = async (options: {
  client: ApiClient;
  payload: BulkUpsertHooksRequest;
}): Promise<BulkUpsertHooksResponse> => {
  const { client, payload } = options;
  const { data } = await client.patch<BulkUpsertHooksResponse>(
    "/hooks/bulk",
    payload
  );
  return data;
};
